import "./Menu.scss";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GlobalContext from "@context/GlobalContext";
import MenuHierarquia from "./MenuHierarquia";
import IconKtech from "@icons/IconKtech";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";

export default function Menu() {
  //Variaveis padrões
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();

  //open
  const [open, setOpen] = useState(false);
  const [menuAberto, setMenuAberto] = useState({});

  useEffect(() => {
    if (Object.keys(menuAberto).length > 0) {
      dispatch({
        type: "SET_MENUABERTO",
        payload: menuAberto,
      });
    } else {
      setMenuAberto(state.menuaberto);
    }
  }, [menuAberto]);

  useEffect(() => {
    setOpen(state.openmenu);
  }, []);

  return (
    <>
      <div>
        <ButtonIcon
          MenuLateral
          className="button-menu-mobile"
          onMenuLateral={() => {
            setOpen(true);
            dispatch({
              type: "SET_OPENMENU",
              payload: true,
            });
          }}
        />
      </div>
      <div className={`menu ${open ? "open" : "exit"}`}>
        <ButtonIcon
          MenuLateral
          className="button-menu-mobile-aberto"
          onMenuLateral={() => {
            setOpen(false);
            dispatch({
              type: "SET_OPENMENU",
              payload: false,
            });
          }}
        />
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <IconKtech
            width="50px"
            height="50px"
            className="iconktech-aberto"
            onClick={() => {
              navigate("/");
            }}
          />
          <IconKtech width="30px" height="30px" className="iconktech-fechado" />
        </div>
        <div>
          {Object.entries(state.menulateral).map(([key, value]) => (
            <ul className="menuhierarquia">
              <MenuHierarquia
                id={key}
                data={value}
                nivel={1}
                menuAberto={menuAberto}
                setMenuAberto={setMenuAberto}
                setOpenTodoMenu={setOpen}
                dispatch={dispatch}
              />
            </ul>
          ))}
        </div>
      </div>
    </>
  );
}
